"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REMOVE_COMMUNICATIONS_WHITELIST = void 0;
const enums_1 = require("../enums");
exports.REMOVE_COMMUNICATIONS_WHITELIST = [
    enums_1.routingKeys.SEND_KIT,
    enums_1.routingKeys.SCHEDULE_CALL,
    enums_1.routingKeys.SEND_SMS,
    enums_1.routingKeys.SEND_EMAIL,
    enums_1.routingKeys.SEND_LETTER,
    enums_1.routingKeys.SEND_PRIORITIZED_OUTREACH,
    enums_1.routingKeys.END_PATIENT_SERVICE,
    enums_1.routingKeys.START_PATIENT_END_OF_SERVICE_COMMUNICATION,
    enums_1.routingKeys.START_PATIENT_END_OF_FOLLOW_UP_SERVICE_COMMUNICATION,
];
